import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

const TaxonomyCertifications = ({ entity, viewMode = false }) => {

  const image = entity.getIn(['field_image', 0, 'styles', 'original']);
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  return (
    <div>
      <CoreLink to={linkUrl}>
        <Image
          lazyload
          includeWebP
          src={image}
        />
      </CoreLink>
    </div>
  );
};

export default TaxonomyCertifications;
